import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sessione-roma-cifrischain',
  templateUrl: './sessione-roma-cifrischain.component.html',
  styleUrls: ['./sessione-roma-cifrischain.component.css']
})
export class SessioneRomaCifrischainComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
